import Multiselect from "../Common/MultiSelect";

const Instructors = ({ data, handleChangeMultiBox, instructor }) => {
    return (
      <Multiselect name="instructors" options={data} displayValue="id"  selectedValues={instructor} onSelect={handleChangeMultiBox} onRemove={handleChangeMultiBox} />
    );
}

export default Instructors;